import * as React from 'react';
import { withNativeProps } from "../../utils/with-native-props";
import './cn-tag-group.scss';
import classNames from 'classnames';
export var CnTagGroup = function (props) {
    return withNativeProps(props, React.createElement("div", { className: classNames(CN_UI_HASH_CLASS_NAME, 'cn-ui-m-tag-group') }, props.children));
};
CnTagGroup.displayName = 'CnTagGroup';
